import React from 'react';
import { BackTop, Icon, Badge, Popover, Carousel, message } from 'antd';
import WidthWrapper from '../constants/WidthWrapper';
import forLayout from '../../use/useForLayout';
import { useDidMount } from '../../use';
import eventBus from './EventBus';
import Context from './Context';
import { network, asserts, generators } from '../../../utils';
import { goChatWithCustomer } from '../../../service/webIm';
import api from '../../../config/api';
import { isNil, isEmpty } from 'ramda';
import { Link } from 'react-router-dom';

// export default () => (
//   <BackTop style={{ right: 8 }}>
//     <Icon type="up-circle" theme="filled" style={{ color: '#7b7364', fontSize: 36 }} />
//   </BackTop>
// );
export default () => {
  const {
    history,
    principal,
    agentList,
    webImNum,
    updateImMsgCnt,
    isSpecialUser,
    permCart,
  } = React.useContext(Context);
  const isUpStorage = JSON.parse(localStorage.getItem('b2bmgmt_isUpStorage'));
  const isLoginIn = asserts.isExist(principal);
  const [defaultList, setDefaultList] = React.useState([]);
  const [cartCount, setCartCount] = React.useState(0);
  const [superList, setSuperList] = React.useState([]);
  const [isUp, setIsUp] = React.useState(isNil(isUpStorage) ? true : isUpStorage); // 上箭头  收起
  // let affixShow = false;
  const visibleWidth = document.documentElement.clientWidth;
  // affixShow = visibleWidth >= 1400 ? true : false;
  const fetchCartCount = async () => {
    const response = await network.get(api.core.cartCount);
    if (response.success) {
      setCartCount(response.data.data || 0);
    }
  };
  React.useEffect(() => {
    const unlisten = history.listen(() => isLoginIn && fetchCartCount() && fetchAgentList());
    return () => unlisten();
  });

  useDidMount(() => {
    if (isLoginIn) {
      fetchCartCount();
      fetchAgentList();
      eventBus.addListener(eventBus.type.UPDATE_CART_COUNT, () => fetchCartCount());
    }
  });

  const handleArrow = () => {
    setIsUp(!isUp);
    localStorage.setItem('b2bmgmt_isUpStorage', !isUp);
  };

  React.useEffect(() => {
    let menuList = [
      !isLoginIn &&
        isUp && {
          icon: `${process.env.TARGET}static/imgs/popCircle/wode.svg`,
          name: '登录',
          content: null,
          onclick: () => {
            window.location.href = `${process.env.TARGET}login`;
          },
        },
      !isLoginIn &&
        isUp && {
          icon: `${process.env.TARGET}static/imgs/popCircle/register.svg`,
          name: '注册',
          content: null,
          onclick: () => {
            window.location.href = `${process.env.TARGET}register`;
          },
        },
      isLoginIn &&
        isUp && {
          icon: `${process.env.TARGET}static/imgs/popCircle/wode.svg`,
          name: '我的',
          content: null,
          onclick: () => {
            window.location.href = `${process.env.TARGET}profile`;
          },
        },
      !isUp && {
        icon: `${process.env.TARGET}static/imgs/popCircle/downArrow.svg`,
        name: '展开',
        content: null,
        onclick: handleArrow,
      },
      isLoginIn &&
        !isEmpty(permCart) &&
        isUp && {
          icon: `${process.env.TARGET}static/imgs/popCircle/cart.svg`,
          name: '购物车',
          code: 'cart',
          content: null,
          onclick: () => {
            window.location.href = `${process.env.TARGET}cart`;
          },
        },
      // isLoginIn &&
      //   isUp && {
      //     icon: `${process.env.TARGET}static/imgs/popCircle/customerService.svg`,
      //     name: '客服',
      //     // code: 'webIm',
      //     content:
      //       superList.length > 0 && superList.some((item) => item.qwAgentLink) ? (
      //         <div className="pointer">
      //           {superList.map((item) => {
      //             if (item.qwAgentLink) {
      //               return (
      //                 <Link key={item.agentId} to={`${item.agentId}`}>
      //                   {item.agentName}
      //                 </Link>
      //               );
      //             }
      //             return null;
      //           })}
      //         </div>
      //       ) : null,
      //     // onclick: handleGoChat,
      //   },
      isUp && {
        icon: `${process.env.TARGET}static/imgs/popCircle/telephone.svg`,
        name: '咨询',
        content: <div className="pointer">0573-82203125 转 377</div>,
        onclick: () => {},
      },
      isLoginIn &&
        isUp && {
          icon: `${process.env.TARGET}static/imgs/popCircle/feedback.svg`,
          name: '反馈',
          content: null,
          onclick: () => {
            window.location.href = `${process.env.TARGET}afterSales/feedback`;
          },
        },
      isUp && {
        icon: `${process.env.TARGET}static/imgs/popCircle/qrcode.svg`,
        name: '关注',
        content: (
          <div>
            <img
              src={`${process.env.TARGET}static/imgs/qr-code.png`}
              style={{ width: 120 }}
              alt="qr-code"
            />
          </div>
        ),
        onclick: () => {},
      },
      isLoginIn &&
        isUp && {
          icon: `${process.env.TARGET}static/imgs/popCircle/wechat.svg`,
          name: '微信',
          content: (
            <div style={{ width: 120 }}>
              <Carousel
                key={superList.length}
                effect="fade"
                autoplay={superList.length > 1}
                dots={false}
                autoplaySpeed={3000}
                pauseOnDotsHover
              >
                {superList.map((item, index) => {
                  return (
                    <React.Fragment key={item.agentId}>
                      <div
                        key={index}
                        style={{
                          textAlign: 'center',
                          width: '120px',
                          display: 'inline-block',
                        }}
                      >
                        <img
                          src={`${process.env.ASSETS}/${item.agentUrl}`}
                          style={{ width: '120px', height: '120px' }}
                          alt="qr-code"
                        />
                        <p style={{ lineHeight: '20px', height: '20px' }}>{item.agentName}</p>
                        <p style={{ lineHeight: '20px', height: '20px' }}>{item.mobile}</p>
                      </div>
                    </React.Fragment>
                  );
                })}
              </Carousel>
            </div>
          ),
        },
      isUp && {
        icon: `${process.env.TARGET}static/imgs/popCircle/gotop.svg`,
        name: '置顶',
        content: null,
        onclick: goBackTop,
      },
      isUp && {
        // icon: isUp
        //   ? `${process.env.TARGET}static/imgs/popCircle/upArrow.svg`
        //   : `${process.env.TARGET}static/imgs/popCircle/downArrow.svg`,
        // name: isUp ? '收起' : '展开',
        icon: `${process.env.TARGET}static/imgs/popCircle/upArrow.svg`,
        name: '收起',
        content: null,
        onclick: handleArrow,
      },
    ].filter(Boolean);
    setDefaultList(menuList);
  }, [isLoginIn, isUp, agentList, superList]);

  const fetchAgentList = async () => {
    const res = await network.get(api.home.exclusiveCustSer);
    const { data = {} } = res.data;
    if (asserts.isExist(data)) {
      const superList = generators.generatorArray(data.agentList) || [];
      setSuperList(superList);
    }
  };

  // const handleGoChat = () => {
  //   if (agentList.length) {
  //     goChatWithCustomer({}, agentList[0].agentImUsername, null, 'GLOBAL', 'BY_GLOBAL', (res) => {
  //       if (res) {
  //         // 初始化为0
  //         updateImMsgCnt({ type: 'init' });
  //       }
  //     });
  //   } else {
  //     message.warn('您所在分公司下没有客服，请联系管理员');
  //   }
  // };

  // const handleScroll = React.useCallback(() => {
  //   let offset = document.getElementById('affixFixed');
  //   if (offset) {
  //     let visibleWidth = document.documentElement.clientWidth,
  //       currentOffset =
  //         window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft;
  //     if (currentOffset + visibleWidth >= 1300) {
  //       offset.style.display = 'block';
  //     } else {
  //       offset.style.display = 'none';
  //     }
  //   }
  // }, []);
  // window.addEventListener('scroll', handleScroll);

  const getWindowResize = React.useCallback(() => {
    let offset = document.getElementById('affixFixed');
    let resizeWidth = document.documentElement.clientWidth;
    if (offset) {
      if (resizeWidth >= 1240) {
        offset.style.display = 'block';
      } else {
        offset.style.display = 'none';
      }
    }
  }, []);

  const debounce = (fn, delay) => {
    let timer;
    return function() {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        fn();
      }, delay);
    };
  };
  const handleDebounce = debounce(getWindowResize, 500);
  window.addEventListener('resize', handleDebounce);

  React.useEffect(() => {
    window.addEventListener('resize', handleDebounce);
    return () => {
      window.removeEventListener('resize', handleDebounce);
    };
  });

  const goBackTop = () => {
    // todo 注意滚动的元素
    const ele = document.getElementById('root');
    //@ts-ignore
    ele.onmousewheel = (e) => {
      //@ts-ignore
      if (window.autoScroll) {
        //@ts-ignore
        window.autoScroll = false;
        clearInterval(scrollTopTimer);
        //@ts-ignore
        ele.onmousewheel = null;
      }
    };
    //@ts-ignore
    window.autoScroll = true;
    let scrollTopTimer = setInterval(function() {
      var top = document.body.scrollTop || document.documentElement.scrollTop;
      var speed = top / 30;
      document.documentElement.scrollTop -= speed;
      if (top <= 1) {
        //@ts-ignore
        window.autoScroll = false;
        document.documentElement.scrollTop = 0;
        clearInterval(scrollTopTimer);
        ele.onmousewheel = null;
      }
    }, 1);
  };

  React.useLayoutEffect(() => {
    const ulDom = document.querySelectorAll('.fixedList ul');
    if (isUp) {
      if (ulDom && Array.from(ulDom).length) {
        let { height } = ulDom[0].getBoundingClientRect();
        let fixedListDom = document.querySelectorAll('.fixedList');
        if (fixedListDom && Array.from(fixedListDom).length) {
          fixedListDom[0].style.marginTop = `-${height / 2}px`;
        }
      }
    }
  }, [defaultList, isUp]);

  const show = forLayout.useShowHeader();
  if (!show || isSpecialUser) return null;

  return (
    <div id="affixFixed">
      <WidthWrapper className="popCircle">
        <div className="fixedList fixed-popCircle">
          <ul>
            {defaultList.map((item, index) => {
              return (
                <li key={index}>
                  {item.content && !asserts.isExist(item.code) ? (
                    <Popover placement="left" content={item.content}>
                      <a onClick={item.onclick}>
                        <img src={item.icon} alt="加载中" className="item-img" />
                        <span>{item.name}</span>
                      </a>
                    </Popover>
                  ) : (
                    <a onClick={item.onclick}>
                      {asserts.isExist(item.code) && item.code === 'cart' ? (
                        <Badge count={cartCount} offset={[0, 0]} showZero overflowCount={999}>
                          <img src={item.icon} alt="加载中" className="item-img" />
                        </Badge>
                      ) : null}
                      {asserts.isExist(item.code) && item.code === 'webIm' ? (
                        <Popover placement="left" content={item.content}>
                          <Badge count={webImNum} offset={[0, 0]} overflowCount={999}>
                            <img src={item.icon} alt="加载中" className="item-img" />
                          </Badge>
                        </Popover>
                      ) : null}
                      {!asserts.isExist(item.code) ? (
                        <img src={item.icon} alt="加载中" className="item-img" />
                      ) : null}
                      <span>{item.name}</span>
                    </a>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </WidthWrapper>
    </div>
  );
};
